<template>
    <div v-if="availableLanguages.length > 1" class="topbar-language">
        <div v-if="!isMobile && !visabilityType" class="navbar-item has-dropdown is-hoverable languages-block">
            <a class="navbar-link">
                <span class="icon">
                    <i class="fas fa-globe" aria-hidden="true"></i>
                </span>
                <span>{{langDescriptions[lang]}}</span>
            </a>
            <div class="navbar-dropdown is-right">
                <a v-for="l in availableLanguages" class="navbar-item" @click="lang=l" :key="l">
                    <span>{{langDescriptions[l]}}</span>
                </a>
            </div>
        </div>
        <div v-if="visabilityType == 'icons'" class="navbar-item has-dropdown is-hoverable languages-block languages-block--icons">
            <a class="navbar-link">
                <span>
                    <img :src="'/static/topbar/flags/'+lang+'.svg'" :alt="lang">
                </span>
            </a>
            <div class="navbar-dropdown is-right">
                <a v-for="l in availableLanguages" v-if="l!=lang" class="navbar-item" @click="lang=l" :key="l">
                    <span>
                        <img :src="'/static/topbar/flags/'+l+'.svg'" :alt="l">
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';
import menuHelper from '../../../helpers/menu.helper';

export default {
    name: 'topbar-language',
    props: ['visabilityType'],
    data() {
        return {
            isMobile: isMobile.phone || isMobile.tablet,
        };
    },
    computed: {
        lang: {
            get() {
                return Vue.state.lang.currentLang;
            },
            set(val) {
                Vue.state.lang.currentLang = val;
            }
        },
        availableLanguages() {
            return Vue.state.lang.availableLanguages;
        },
        langDescriptions() {
            return Vue.state.lang.langDescriptions;
        },
        langShorts(){
            return Object.keys(this.langDescriptions);
        }
    },
    mounted() {
        this.lang = this.availableLanguages.find(item => item === this.lang) || this.availableLanguages[0]
    }
}
</script>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/topbar/topbar-language.vue